import * as React from 'react'
import {Link} from '@frontrow/console/src/components/ui/link'
import {H2} from '@frontrow/console/src/components/typography'

import WarningIcon from '@frontrow/console/src/components/common/warning-icon'
import * as style from './roster-item.module.scss'

type RosterItemProps = {
  url: string
  title: string
  description: string
  warning?: string
}

export default function RosterItem(props: RosterItemProps): React.ReactElement {
  const {url, title, description, warning} = props
  const warningMsg =
    warning !== null && warning !== undefined ? (
      <div className={style.rosteItemContent}>
        <WarningIcon />
        <b>{warning}</b>
      </div>
    ) : null

  return (
    <Link href={url} addClass={style.rosterItem}>
      <H2 addClass={style.rosterItemTitle}>{title}</H2>
      <p className={style.rosteItemContent}>{description}</p>
      {warningMsg}
    </Link>
  )
}
